module.exports = __webpack_public_path__ + "img/bag.0f0159c2.svg";